import { FunctionComponent } from "react";
import { StyledItem } from "./item.styles";
import { useLocation } from "react-router";

interface ItemProps {
  children: any;
  to: string;
  pattern?: string | RegExp;
  disabled?: boolean;
}

const isSelected = (pathname: string, pattern: string | RegExp | undefined) => {
  if (!pattern) {
    return false;
  }

  if (typeof pattern === "string") {
    return pathname.includes(pattern);
  }

  return pattern.test(pathname);
};

const NavigationItem: FunctionComponent<ItemProps> = ({
  children,
  to,
  pattern = to,
  disabled = false,
}) => {
  const location = useLocation();
  const { pathname } = location;

  const selected = isSelected(pathname, pattern);

  return (
    <StyledItem $selected={selected} $disabled={disabled} to={to}>
      {children}
    </StyledItem>
  );
};

export default NavigationItem;
